// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconTravelsPath = 'M17.935 10.741a.504.504 0 0 1-.449.259h-4.563L9.25 16.655c-.191.22-.466.345-.762.345H6.401l2.006-6H3.006A1 1 0 0 1 2 10.011V7.124C2.738 7.652 3.72 8 5.012 8h9.266a4.07 4.07 0 0 1 3.467 1.944l.182.302a.474.474 0 0 1 .008.495ZM6.545 3h1.639c.32 0 .622.156.808.417L10.828 6H7.914L6.545 3Zm13.094 6.212-.183-.302A6.08 6.08 0 0 0 14.278 6h-.996l-2.66-3.742A2.998 2.998 0 0 0 8.184 1h-4.75l2.283 5h-.705C2.178 6 2.006 3.496 2 3H0v7.011A3.001 3.001 0 0 0 3.006 13h2.623l-2.006 6h4.865c.919 0 1.775-.41 2.349-1.125L14.009 13h3.477c.921 0 1.74-.478 2.191-1.277a2.462 2.462 0 0 0-.038-2.511Z';
var IconTravels = baseIcon('IconTravels', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconTravelsPath
});
export default IconTravels;
//# sourceMappingURL=index.js.map